<template>
  <div class="card-single">
    <div class="card-place">
      <div
        class="card-pnc relative text-center flex justify-center items-center mb-5"
      >
        <span class="text-12 text-label font-bold tracking-normal uppercase">
          {{ card.holder_name || "" }}
        </span>
        <button
          type="button"
          :disabled="$getState('isBankAuthorized')"
          class="card-pnc__i absolute block flex justify-center items-center text-14 font-bold tracking-normal text-label accountMenuIcon"
        >
          <ThreeDots />
        </button>
        <transition
          v-if="accountMenu"
          enter-active-class="transition ease-out duration-100"
          enter-from-class="transform opacity-0 scale-95"
          enter-to-class="transform opacity-100 scale-100"
          leave-active-class="transition ease-in duration-75"
          leave-from-class="transform opacity-100 scale-100"
          leave-to-class="transform opacity-0 scale-95"
        >
          <ul class="plaid-dropdown-menu absolute pt-1">
            <li class="">
              <button
                v-ripple
                class="text-label text-14 w-full rounded-b bg-gray-200 hover:bg-gray-400 py-2 px-4 block whitespace-no-wrap relative"
                type="button"
                @click="$setState('setConfirmModal', true)"
              >
                {{ $t("Delete") }}
              </button>
            </li>
            <li class="">
              <button
                v-ripple
                class="text-label text-14 w-full rounded-b bg-gray-200 hover:bg-gray-400 py-2 px-4 block whitespace-no-wrap relative"
                type="button"
                @click="reCreateAccount"
              >
                {{ $t("Re-Authorize") }}
              </button>
            </li>
          </ul>
        </transition>
      </div>
      <div
        class="card-place__number text-16 text-text font-bold tracking-tight"
      >
        **** **** **** <span v-if="!!card.last4">{{ card.last4 }}</span>
      </div>
      <div
        class="card-place__number text-12 text-label font-bold tracking-tight pt-3 flex justify-between"
      >
        <div>
          <div class="text-11 font-normal text-light_grey">
            {{ $t("Card Holder") }}
          </div>
          <div v-if="!!card.holder_name">{{ card.holder_name }}</div>
          <div class="text-center" v-else>---</div>
        </div>
      </div>
      <div class="switcher-container flex justify-between items-center pt-3">
        <span class="text-label text-14 font-bold tracking-normal pr-2"
          >{{ $t("Performance Select Checking") }}
        </span>
        <label
          :for="`donationPause-${card.id}`"
          class="input-switcher"
          :class="{
            'input-switcher_checked': psc
          }"
        >
          <input
            :id="`donationPause-${card.id}`"
            type="checkbox"
            v-model="psc"
            :disabled="$getState('isBankAuthorized')"
            @change="savePosActive"
          />
        </label>
      </div>
      <div
        class="mt-4 flex justify-center"
        v-if="
          $getState('isBankAuthorized') &&
            card.id == $getState('isBankAuthorized')
        "
      >
        <Button
          type="button"
          text="Re Authorized"
          :click-handler="reCreateAccount"
        />
      </div>
    </div>
    <ConfirmModal
      content="Would you like to delete this Bank Account ?"
      @yes="deleteCard"
      @no="$setState('setConfirmModal', false)" 
    />
  </div>
</template>

<script>
import ConfirmModal from '../Modal/ConfirmModal.vue';
import ThreeDots from '../Icons/ThreeDots.vue';
import Button from "../UI/Button";
export default {
  name: "BankItem",
  components: { 
    ConfirmModal,
    ThreeDots,
    Button
  },
  props: ["card", "clickHandler"],

  data: function() {
    return {
      psc: false,
      accountMenu: false
    };
  },

  created() {
    const onClickOutside = e => {
      if (
        !e.target.classList.contains("accountMenuIcon") &&
        this.$el.contains(e.target)
      ) {
        this.accountMenu = false;
      } else if (
        e.target.classList.contains("accountMenuIcon") &&
        this.$el.contains(e.target)
      ) {
        this.accountMenuHandler();
      } else {
        this.accountMenu = this.$el.contains(e.target);
      }
    };
    document.addEventListener("click", onClickOutside);
    this.$on("hook:beforeDestroy", () =>
      document.removeEventListener("click", onClickOutside)
    );
  },

  mounted() {
    this.psc = this.card.is_pos;
  },

  methods: {
    accountMenuHandler() {
      this.accountMenu = !this.accountMenu;
    },

    deleteCard () {
      this.$setState('setConfirmModal', false)
      this.$emit("actionWithCard", {
        action: "deletePlaidAccount",
        index: this.card.id
      })
    },

    reCreateAccount: function() {
      this.$emit("actionWithCard", {
        action: "reCreateAccount",
        index: this.card.id
      });
    },

    savePosActive: function() {
      this.$emit("actionWithCard", {
        action: "savePos",
        index: this.card.id
      });
    }
  }
};
</script>
